import { render } from "./logo_black.vue?vue&type=template&id=4313efe3&scoped=true"
import script from "./logo_black.vue?vue&type=script&lang=js"
export * from "./logo_black.vue?vue&type=script&lang=js"

import "./logo_black.vue?vue&type=style&index=0&id=4313efe3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4313efe3"]])

export default __exports__